import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message, Button, Form, Table } from 'antd'
import { Queries, Mutations } from '../../../../../graphql'
import Container from '../../../../../components/user/Container'
import FormInputAddress from '../../../../../components/user/FormInputAddress'
import TabsBlockProFile from '../../../../../components/user/TabsBlockProFile'
import { datasetsProfileDetail, tabProfile } from '../../../../../config/datasetsProfile'
import { checkType } from '../../../../../utils/checkType'
import { pushAge } from '../../../../../utils/formatdate'
import moment from 'moment'
import { convertToHTMl } from '../../../../../utils/markDown'
import { urlLinkFile } from '../../../../../utils/setting'

const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

class condition1 extends Component {
	state = {
		dataTableChangProvidentFund:[],
        columnsProvidentFund:[
            {
                title: 'เปอร์เซ็นต์สะสม',
                dataIndex: 'slipNo',
                width:'100',
				align:'left',
                vertical:'top',
                render: (item, record, index) => {

                }
            },
            {
                title: 'วันที่แก้ไข',
                dataIndex: 'slipNo',
                width:'100',
				align:'left',
                vertical:'top',
                render: (item, record, index) => {

                }
            }
        ],
        dataTableChangPeopleFund:[],
        columnsPeopleFund:[
            {
                title: 'คนที่',
                dataIndex: 'slipNo',
                width:'100',
				align:'left',
                vertical:'top',
                render: (item, record, index) => {

                }
            },
            {
                title: 'ชื่อ - นามสกุล',
                dataIndex: 'slipNo',
                width:'100',
				align:'left',
                vertical:'top',
                render: (item, record, index) => {

                }
            },
            {
                title: 'เลขที่บัตรประชาชน',
                dataIndex: 'slipNo',
                width:'100',
				align:'left',
                vertical:'top',
                render: (item, record, index) => {

                }
            },
            {
                title: 'เปอร์เซ็นต์ที่ได้รับ',
                dataIndex: 'slipNo',
                width:'100',
				align:'left',
                vertical:'top',
                render: (item, record, index) => {

                }
            }
        ],
        modalCondition1: false,
        modalCondition2: false
	}

    showModalCondition1 = async () =>{
        await this.setState({
            modalCondition1: true
        })
    }

    hideModalCondition1 = async () =>{
        await this.setState({
            modalCondition1: false
        })
    }

    showModalCondition2 = async () =>{
        await this.setState({
            modalCondition2: true
        })
    }

    hideModalCondition2 = async () =>{
        await this.setState({
            modalCondition2: false
        })
    }


	async componentDidMount(){
    }

	render() {
		const { dataForm} = this.props
		const { 
                dataTableChangProvidentFund, 
                columnsProvidentFund, 
                columnsPeopleFund, 
                dataTableChangPeople,
                modalCondition1,
                modalCondition2
            } = this.state
		return (
			<div className="px-5 py-1 card-bg-green">
                <Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
                    <TabPane tab={'กองทุนสำรองเลี้ยงชีพ'} key="2" className="mb-0">
                        <Row gutter={16}>
                            <Col xs={24} md={12} className="pt-2 mb-3">
                                <strong className="color-red">
                                    การสมัครสมาชิกกองทุน
                                </strong>
                            </Col>
                            <Col xs={24} md={12} className="mb-3" align="right">
                                {
                                    dataForm.applicationProvidentFund && 
                                        dataForm.applicationProvidentFund.isBtnActive &&
                                        <a href={urlLinkFile(dataForm.applicationProvidentFund.fileData)} className="btn-color-default color-white bg-red px-3 py-2" target="_blank">
                                            ดาวน์โหลดแบบฟอร์มการสมัคร
                                        </a>
                                }
                               
                            </Col>
                            <Col md={24}>
                                <div 
                                    className="mt-2 custom-width-tooltip " 
                                    dangerouslySetInnerHTML={{ __html: convertToHTMl(dataForm.applicationProvidentFund ? dataForm.applicationProvidentFund.fyi : '') }}
                                /> 
                                {/* <p>บุคลากรสามารถสมัครสมาชิกกองทุน โดยมีขั้นตอนดังนี้</p>
                                <ol>
                                    <li>
                                        ดาวน์โหลดแบบฟอร์มการสมัคร
                                    </li>
                                    <li>
                                        กรอกข้อมูลให้ครบถ้วน และยื่นส่งให้เจ้าหน้าที่
                                    </li>
                                    <li>
                                        รอเจ้าหน้าที่ติดต่อรายงานผล
                                    </li>
                                </ol> */}
                            </Col>
                        </Row>
                    </TabPane>
                </Tabs>
            </div>
		)
	}
}

condition1.propTypes = {
	//
}

export default withApollo(condition1)
